export default __webpack_public_path__ + "static/media/settings2.a0129e8e.gif";